export enum ButtonSize {
  MEDIUM = 'button-medium',
  LARGE = 'button-large',
}

export enum ButtonMode {
  FILL = 'fill',
  INLINE = 'inline',
  FILL_MOBILE = 'fill-mobile',
}

export enum ButtonTheme {
  PRIMARY_ACCENT = 'primary-accent',
  SECONDARY_OUTLINE = 'secondary-outline',
  SECONDARY_OUTLINE_REVERSED = 'secondary-outline-reversed',
  TERTIARY_GHOST = 'tertiary-ghost',
  TERTIARY_GHOST_REVERSED = 'tertiary-ghost-reversed',
}

export enum ButtonType {
  SUBMIT = 'submit',
  BUTTON = 'button',
  MENU = 'menu',
  RESET = 'reset',
}
